import FlexContainer from 'components/common/FlexContainer';
import { borderStyles } from 'styles/theme';
import styled from '@emotion/styled';

export const Card = styled(FlexContainer)({
  borderStyle: 'solid',
  borderWidth: 1,
  borderColor: borderStyles.colors.primary,
  borderRadius: 6,
});
